import React, { useEffect, useState } from 'react';
import { GAME_STATUS_INACTIVE, GAME_STATUS_WON } from '../../actions/game';
import { playSound, stopSound } from '../../utils/audio-helper';
import './index.css';

const ResultScreen = props => {

	const { transitionOut, status, points, sounds, avatar } = props,
		[isWinner, setIsWinner] = useState(status===GAME_STATUS_WON),
		[isInactive, setIsInactive] = useState(status===GAME_STATUS_INACTIVE),
		// [isWinner, setIsWinner] = useState(true), //winner result test
		[isTopScorer, setIsTopScorer] = useState(status===GAME_STATUS_WON && points>=1000),
		resultClassName = (isWinner && 'won') || (isInactive && 'inactive') || 'lost',
		resultMessage = (isTopScorer && 'Top Score!') || (isWinner && 'You Won!') || (isInactive && 'Play the Game!') || 'Nice Try!',
		progressionCTA = 
			isWinner ? 
				null
				:
				<a className="replay-btn" onClick={()=>{transitionOut('game')}}>Play{(!isInactive && ' Again') || ''}</a>,

		handleAnimationEnd = evt => {
			const { animationName } = evt;

			if (animationName === 'scrolling-bg') {
				// transitionOut('game');
			} 
		};

	useEffect(()=>{
		stopSound(sounds, 'game');
		if (isWinner) {
			// playSound(sounds, 'winning', {volume: 0.2});
		} else {
			// playSound(sounds, 'lose', {volume: 0.2});
		}
	},[]);

	return (
		<div className={"split-second-result " + resultClassName} onAnimationEnd={handleAnimationEnd}>
			<header>
				<div className='logo-container'>
					<div className="logo" />
				</div>
			</header>
			<div className="result-message">
				{resultMessage}
			</div>
			<div className="cta-container">
				{progressionCTA}				
				<a className="external-btn" target="_blank" href="https://blog.gameshownetwork.com/watch-split-second/">Watch Show</a>
				<a className="external-btn" target="_blank" href="https://www.gameshownetwork.com/games">All Games</a>
			</div>
			<div className="tunein"><gsntv-wc-tune-in show-id="split-second"></gsntv-wc-tune-in></div>
		</div>
	)
}

export default ResultScreen;